export const executeIfFunction = (value, ...payload) =>
    typeof value === 'function' ?
        value(...payload) :
        value;
